// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

export const plansTranslationsNl = {
  'plans.modal.title': 'Upgrade abonnement',
  'plans.modal.comparison_title': 'Vergelijking van abonnementen',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': '30.000 tekens per maand per account.',
  'plans.modal.free.line2': 'Maximaal 2 contacten per gebruiker.',
  'plans.modal.free.line3': 'Maximaal 2 actieve gesprekken per account.',
  'plans.modal.free.line4': 'Geen bijlagen of opslagruimte.',
  'plans.modal.free.line5': 'Geen gegevensexport.',
  'plans.modal.free.line6': 'Berichtgeschiedenis tot 30 dagen.',
  'plans.modal.free.line7': 'Slechts 1 apparaat per gebruiker.',
  'plans.modal.premium.line1': '300.000 tekens per maand per account.',
  'plans.modal.premium.line2': 'Maximaal 100 contacten per gebruiker.',
  'plans.modal.premium.line3': 'Onbeperkte gesprekken en chats (tenant).',
  'plans.modal.premium.line4': 'Tot 50 MB opslag (tenant).',
  'plans.modal.premium.line5': 'Tot 3 apparaten per gebruiker.',
  'plans.modal.premium.line6': 'Onbeperkte uitnodigingen (tenant).',
  'plans.modal.premium.line7': 'Inclusief export, automatische vertaling en bestanden binnen planlimieten.',
  'plans.modal.premium_block_heading': 'Gebruikslimieten van de engine (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder-programma',
  'plans.modal.foundation.categories_title': 'Founder-categorieën ({slots} plekken)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Positie 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'De eersten die het project steunden. Hoogste historische prioriteit.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Positie 26–75',
  'plans.modal.foundation.cat_early_desc': 'Vroege steun met speciale erkenning.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Positie 76–150',
  'plans.modal.foundation.cat_std_desc': 'Founder-plek binnen de 150 plaatsen.',
  'plans.modal.foundation.advantages_title': 'Founder-voordelen',
  'plans.modal.foundation.adv1': 'Toegang tot de beperkte Founder-pool ({slots} genummerde plekken).',
  'plans.modal.foundation.adv2': 'Erkenning als oprichtende gebruiker van ArChat.',
  'plans.modal.foundation.adv3': 'Founder-badge en -aanwezigheid in de productervaring.',
  'plans.modal.foundation.adv4': 'Historische prioriteit en status op basis van je positie (1–150).',
  'plans.modal.foundation.adv5': 'Doorlopend voordeel gekoppeld aan je Founder-toegang zolang het huidige beleid geldt.',
  'plans.modal.pro.tagline': 'Standaard premium — zonder Founder-component',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Gratis abonnement',
  'plans.free.price': '$0 / maand',
  'plans.free.features.contacts': 'Maximaal 2 contacten per gebruiker',
  'plans.free.features.conversations': 'Maximaal 2 actieve gesprekken per account',
  'plans.free.features.no_export': '30.000 tekens/maand per account; 34 berichten/dag en 1.000/maand; geen export',
  'plans.free.features.no_advanced': 'Geen bestanden of opslag; 30 dagen geschiedenis; 1 apparaat per gebruiker',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founder-abonnement',
  'plans.foundation.price': '$15 / maand',
  'plans.foundation.features.contacts': 'Zelfde premiumcontract als PRO (max. 100 contacten per gebruiker)',
  'plans.foundation.features.conversations': 'Onbeperkte chats (tenant); dezelfde limieten als PRO',
  'plans.foundation.features.badge': 'Founder-programma (150 genummerde plekken)',
  'plans.foundation.features.support': 'USD 15/maand zolang Founder-plekken beschikbaar zijn',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Pro-abonnement',
  'plans.pro.price': '$19 / maand',
  'plans.pro.features.contacts': 'Maximaal 100 contacten per gebruiker',
  'plans.pro.features.conversations': 'Onbeperkte chats (tenant); 1.667 berichten/dag, 50k/maand',
  'plans.pro.features.export': 'Max. 50 MB (tenant); export, automatische vertaling en bestanden volgens plan',
  'plans.pro.features.notifications': 'Max. 3 apparaten per gebruiker; onbeperkte uitnodigingen (tenant)',
  'plans.actions.free': 'Huidig abonnement',
  'plans.actions.foundation': 'Word Founder',
  'plans.actions.pro': 'Upgrade naar PRO',
  'plans.badges.recommended': 'AANBEVOLEN',
  'plans.badges.limited': 'BEPERKT',
  'plans.compare.title': 'Kies je plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.free.price': '$0 / maand',
  'plans.compare.foundation.price': '$15 / maand',
  'plans.compare.pro.price': '$19 / maand',
  'plans.compare.foundation.badge': '150 beperkte plaatsen',
  'plans.compare.cta.foundation': 'Word Founder',
  'plans.compare.cta.pro': 'Upgrade naar PRO',
  'plans.compare.active': 'Huidig plan',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Berichtenlimiet bereikt',
  'plans.limit.message.messages': 'Je hebt je berichtenlimiet bereikt. Upgrade naar FOUNDATION of PRO.',
  'plans.limit.title.storage': 'Opslaglimiet bereikt',
  'plans.limit.message.storage': 'Je hebt je opslaglimiet bereikt. Upgrade voor meer bestanden.',
  'plans.limit.title.invitations': 'Uitnodigingslimiet bereikt',
  'plans.limit.message.invitations': 'Je hebt je uitnodigingslimiet bereikt. Upgrade voor meer contacten.',
  'plans.founder.remaining': 'Nog {count} Founder-plaatsen',
  'plans.founder.remaining_last': 'Laatste {count} Founder-plaatsen',
  'plans.founder.remaining_limited': 'Beperkt: nog {count} plaatsen',
  'plans.founder.remaining_very_low': 'Nog maar {count} Founder-plaatsen',
  'plans.founder.soldout': 'Founder uitverkocht',
  'plans.limit.reached': 'Limiet bereikt — Upgrade plan',
  'plans.compare.pro.adjustment_notice': 'De prijs kan worden aangepast op basis van de servicevoorwaarden.',
  'plans.compare.institucional.price': 'Maatwerkprijs',
  'plans.compare.institucional.title': 'Institutioneel',
  'plans.compare.yourPlan': 'Jouw plan',
  'plans.payments_disabled.title': 'Abonnementen',
  'plans.payments_disabled.message': 'Abonnementen worden geleidelijk geactiveerd. Je kunt de beschikbare plannen en hun voordelen bekijken.',
  'plans.payments_disabled.confirm': 'OK',
};